<template>
  <div class="layer-tree">
    <div v-if="!layers.length" class="empty-state">No layers in this project</div>
    <section v-for="group in groups" :key="group.name" class="layer-group">
      <div class="tree-group-heading"><span class="chevron">⌄</span>{{ group.name }}</div>
      <button
        v-for="layer in group.layers"
        :key="layer.id"
        class="layer-row"
        :class="{ active: layer.id === activeLayerId, muted: !layer.visible }"
        @click="$emit('activate', layer)"
        @contextmenu.prevent="openContext($event, layer)"
      >
        <span class="visibility" @click.stop="$emit('toggle-visibility', layer)">{{ layer.visible ? '◉' : '○' }}</span>
        <span class="layer-icon">{{ iconFor(layer) }}</span>
        <span class="layer-name" :title="layer.name">{{ layer.name }}</span>
        <span v-if="layer.type === 'vector'" class="feature-count">{{ layer.metadata.featureCount.toLocaleString() }}</span>
      </button>
    </section>
    <div v-if="context" class="context-menu" :style="{ left: context.x + 'px', top: context.y + 'px' }">
      <button @click="emitAction('zoom')">Zoom to Layer</button>
      <button v-if="context.layer.type === 'vector'" @click="emitAction('table')">Open Attribute Table</button>
      <button @click="emitAction('properties')">Properties</button>
      <button v-if="context.layer.type === 'vector'" @click="emitAction('style')">Style</button>
      <hr>
      <button @click="emitAction('duplicate')">Duplicate</button>
      <button @click="emitAction('rename')">Rename</button>
      <button v-if="context.layer.type === 'vector'" @click="emitAction('export')">Export</button>
      <hr>
      <button class="danger" :disabled="context.layer.system" @click="emitAction('remove')">Remove</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayerTree',
  props: { layers: { type: Array, required: true }, activeLayerId: { type: String, default: null } },
  data: () => ({ context: null }),
  computed: {
    groups() {
      const definitions = [
        { name: 'Basemap & Web', layers: this.layers.filter(layer => layer.system || ['xyz', 'wms', 'wmts', 'tile'].includes(layer.type)) },
        { name: 'Vector', layers: this.layers.filter(layer => layer.type === 'vector') },
        { name: 'Raster', layers: this.layers.filter(layer => layer.type === 'raster') }
      ]
      return definitions.filter(group => group.layers.length)
    }
  },
  mounted() { window.addEventListener('click', this.closeContext) },
  beforeDestroy() { window.removeEventListener('click', this.closeContext) },
  methods: {
    iconFor(layer) { return layer.type === 'vector' ? '◇' : layer.type === 'raster' ? '▧' : '▦' },
    openContext(event, layer) { this.context = { layer, x: event.clientX, y: event.clientY } },
    closeContext() { this.context = null },
    emitAction(type) { this.$emit('action', { type, layer: this.context.layer }); this.closeContext() }
  }
}
</script>

<style scoped>
.layer-tree { height: 100%; overflow: auto; padding: 4px 0 10px; color: var(--text); font-size: 12px; }
.tree-group-heading { color: var(--muted); font-size: 10px; font-weight: 700; letter-spacing: .08em; padding: 8px 10px 3px; text-transform: uppercase; }
.chevron { color: var(--subtle); font-size: 14px; margin-right: 5px; }
.layer-row { align-items: center; background: transparent; border: 0; color: inherit; cursor: pointer; display: flex; font: inherit; gap: 7px; height: 28px; padding: 0 8px; text-align: left; width: 100%; }
.layer-row:hover { background: var(--hover); }.layer-row.active { background: var(--active); }.layer-row.muted { color: var(--subtle); }
.visibility { color: #9bb5d1; font-size: 12px; width: 14px; }.layer-icon { color: #65b6ff; font-size: 14px; width: 12px; }.layer-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }.feature-count { color: var(--subtle); font-size: 10px; margin-left: auto; }
.empty-state { color: var(--subtle); padding: 16px 12px; }.context-menu { background: var(--menu); border: 1px solid var(--border-strong); box-shadow: 0 10px 30px #0008; min-width: 165px; padding: 4px; position: fixed; z-index: 30; }.context-menu button { background: transparent; border: 0; color: var(--text); cursor: pointer; display: block; font: inherit; padding: 7px 9px; text-align: left; width: 100%; }.context-menu button:hover:not(:disabled) { background: var(--active); }.context-menu button:disabled { color: var(--subtle); cursor: not-allowed; }.context-menu .danger { color: #ff8888; }.context-menu hr { border: 0; border-top: 1px solid var(--border); margin: 4px 0; }
</style>
